import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import confetti from "canvas-confetti";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const Success = () => {
  const { t } = useTranslation();

  useEffect(() => {
    confetti({
      particleCount: 150,
      spread: 100,
      origin: { y: 0.6 },
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-emerald-50 to-white px-4">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 150, damping: 12 }}
        className="text-primary"
      >
        <CheckCircle2 size={120} strokeWidth={1.5} />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="text-4xl font-bold text-gray-900 mt-6 text-center"
      >
        {t("payment-success")} 🎉
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="text-gray-600 mt-3 text-lg text-center max-w-md"
      >
        {t("thank-you")} {t("payment-processed")}<span className="font-semibold">LiBooking</span>{" "}
        
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="flex gap-4 mt-10"
      >
        <Link
          to="/me/stay-bookings"
          className="px-6 py-3 bg-primary text-white rounded-2xl shadow hover:bg-emerald-700 transition text-lg"
        >
          {t("view-my-bookings")}
        </Link>
        <Link
          to="/"
          className="px-6 py-3 border border-primary text-primary rounded-2xl shadow hover:bg-emerald-50 transition text-lg"
        >
          {t("back-to-home")}
        </Link>
      </motion.div>
    </div>
  );
};

export default Success;
